import UploadListItem from "./UploadListItem";
import { useUploadProgress } from "contexts/UploadContext";

interface UploadListProps {
  activeChatId: string;
  className?: string;
}

export default function UploadList({
  activeChatId,
  className,
}: UploadListProps) {
  const { uploads: uploadMap } = useUploadProgress();
  // Filter upload statuses by activeChatId and flatten into a list.
  const uploadList = Object.values(uploadMap[activeChatId] ?? {});

  if (uploadList.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {uploadList.map((upload) => (
        <div key={upload.fileName} className="mt2 mt3-ns">
          <UploadListItem upload={upload} />
        </div>
      ))}
    </div>
  );
}
